import { CouponsReport } from "./CouponsReport";

export * from "./types"

export default CouponsReport;
